(function () {
  'use strict';

  /* @ngdoc object
   * @name bmfexport
   * @description
   *
   */
  angular
    .module('vcfinance.bmfexport', [
      'ui.router',
      'ui.bootstrap'
    ]);
}());
